import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M36.5 97a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M96.5 30a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M12 84c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M80.29 17.83H74.1c-.69 0-1.26.56-1.26 1.26v10.89l-13.42-10.7a2.9 2.9 0 0 0-3.63 0L33.67 36.91v39.71c0 2.4 1.95 4.35 4.35 4.35h39.17c2.4 0 4.35-1.95 4.35-4.35V19.09c0-.69-.56-1.26-1.26-1.26z"
    />
    <path
      fill="#D8FFFF"
      d="M50.65 51.17h14.11c1.31 0 2.37 1.06 2.37 2.37v27.43H48.29V53.54c0-1.31 1.06-2.37 2.37-2.37z"
    />
    <path
      fill="#0597A3"
      d="M24.97 44.81c-.92 0-1.83-.42-2.42-1.23a3 3 0 0 1 .64-4.19l30.06-22.05a7.31 7.31 0 0 1 8.69 0l30.07 22.05c1.34.98 1.62 2.86.64 4.19a2.994 2.994 0 0 1-4.19.65L58.4 22.18a1.35 1.35 0 0 0-1.6 0L26.74 44.23c-.53.39-1.16.58-1.77.58M86.05 83.97H28.92c-1.66 0-3-1.34-3-3s1.34-3 3-3h57.13c1.66 0 3 1.34 3 3s-1.34 3-3 3M27.64 23.07h-5.57V17.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H13.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#00D8D8"
      d="m110.443 46.443-3.941 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94c-.59.59-.59 1.54 0 2.12.591.58 1.54.59 2.12 0l3.94-3.94 3.941 3.94c.59.59 1.539.59 2.119 0s.59-1.54 0-2.12l-3.939-3.94 3.939-3.94c.59-.59.59-1.54 0-2.12s-1.539-.59-2.119 0M52.995 102a2.004 2.004 0 0 1-1.41-3.42l16.5-16.5c.78-.78 2.05-.78 2.83 0s.78 2.05 0 2.83l-16.51 16.5c-.39.39-.9.59-1.41.59"
    />
    <path
      fill="#0597A3"
      d="M80.995 91c10.493 0 19-8.507 19-19s-8.507-19-19-19-19 8.507-19 19 8.507 19 19 19"
    />
    <path
      fill="#00D8D8"
      d="M80.995 87c8.284 0 15-6.716 15-15s-6.716-15-15-15-15 6.716-15 15 6.716 15 15 15"
    />
    <path
      fill="#D8FFFF"
      d="M84.885 83.21c-.78 0-1.52-.46-1.84-1.22-.43-1.02.05-2.19 1.06-2.62a7.995 7.995 0 0 0 4.89-7.37c0-1.1.9-2 2-2s2 .9 2 2c0 4.83-2.88 9.17-7.33 11.06-.25.11-.52.16-.78.16z"
    />
  </svg>
);
const SvgEnrichedIconHomeSearchInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconHomeSearchInverted);
export default Memo;
